import React from 'react';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function PrivacyPolicy() {
  return <div className="min-h-screen bg-white" data-id="element-309">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100 px-4 py-4" data-id="element-310">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-311">
          <a href="#/" className="text-2xl font-bold text-[#1B2A4A] tracking-tight" data-id="element-312">
            Bevo Coastal <span className="text-[#E8913A]" data-id="element-313">Investments</span>
          </a>
          <a href="#/" className="inline-flex items-center text-[#1B2A4A] font-medium hover:text-[#E8913A] transition-colors text-sm" data-id="element-314">
            <ArrowLeftIcon className="w-4 h-4 mr-1.5" data-id="element-315" />
            Back to Home
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-16 md:py-24" data-id="element-316">
        <div className="flex items-center gap-3 mb-8" data-id="element-317">
          <div className="w-10 h-10 bg-[#E8913A]/10 rounded-lg flex items-center justify-center" data-id="element-318">
            <ShieldCheckIcon className="w-5 h-5 text-[#E8913A]" data-id="element-319" />
          </div>
          <div data-id="element-320">
            <h1 className="text-3xl md:text-4xl font-extrabold text-[#1B2A4A]" data-id="element-321">
              Privacy Policy
            </h1>
            <p className="text-slate-500 text-sm mt-1" data-id="element-322">
              Last updated: March 1, 2026
            </p>
          </div>
        </div>

        <div className="prose prose-slate max-w-none space-y-8" data-id="element-323">
          <section data-id="element-324">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-325">
              1. Information We Collect
            </h2>
            <p className="text-slate-600 leading-relaxed mb-3" data-id="element-326">
              When you use bevocoastalinvestments.com, we may collect the
              following information:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-327">
              <li data-id="element-328">
                <strong data-id="element-329">Personal Information:</strong> Name, email address,
                phone number, and property address that you provide through our
                forms.
              </li>
              <li data-id="element-330">
                <strong data-id="element-331">Property Information:</strong> Details about the
                property you are looking to sell, including address, condition,
                and any additional details you share.
              </li>
              <li data-id="element-332">
                <strong data-id="element-333">Usage Data:</strong> Information about how you interact
                with our website, including pages visited, time spent, browser
                type, and device information.
              </li>
              <li data-id="element-334">
                <strong data-id="element-335">Cookies &amp; Tracking:</strong> We use cookies and
                similar technologies to improve your experience and analyze
                website traffic.
              </li>
            </ul>
          </section>

          <section data-id="element-336">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-337">
              2. How We Use Your Information
            </h2>
            <p className="text-slate-600 leading-relaxed mb-3" data-id="element-338">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-339">
              <li data-id="element-340">Evaluate your property and prepare a cash offer</li>
              <li data-id="element-341">
                Contact you regarding your inquiry and provide updates on your
                offer
              </li>
              <li data-id="element-342">Improve our website, services, and user experience</li>
              <li data-id="element-343">
                Send relevant communications (you can opt out at any time)
              </li>
              <li data-id="element-344">Comply with legal obligations</li>
            </ul>
          </section>

          <section data-id="element-345">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-346">
              3. Information Sharing
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-347">
              We do not sell your personal information to third parties. We may
              share your information with trusted service providers who assist
              us in operating our business (such as title companies, attorneys,
              and closing agents) solely for the purpose of completing a
              transaction. We may also disclose information when required by law
              or to protect our legal rights.
            </p>
          </section>

          <section data-id="element-348">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-349">
              4. Data Security
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-350">
              We implement industry-standard security measures, including
              256-bit SSL encryption, to protect your personal information from
              unauthorized access, alteration, or disclosure. While no method of
              transmission over the internet is 100% secure, we take reasonable
              steps to safeguard your data.
            </p>
          </section>

          <section data-id="element-351">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-352">
              5. Your Rights
            </h2>
            <p className="text-slate-600 leading-relaxed mb-3" data-id="element-353">
              Depending on your location, you may have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2" data-id="element-354">
              <li data-id="element-355">Access the personal information we hold about you</li>
              <li data-id="element-356">Request correction of inaccurate information</li>
              <li data-id="element-357">Request deletion of your personal information</li>
              <li data-id="element-358">Opt out of marketing communications</li>
              <li data-id="element-359">Request a copy of your data in a portable format</li>
            </ul>
            <p className="text-slate-600 leading-relaxed mt-3" data-id="element-360">
              To exercise any of these rights, please contact us at{' '}
              <a href="mailto:Info@bevocoastalinvestments.com" className="text-[#E8913A] hover:underline" data-id="element-361">
                Info@bevocoastalinvestments.com
              </a>
              .
            </p>
          </section>

          <section data-id="element-362">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-363">
              6. Cookies
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-364">
              Our website uses cookies to enhance functionality and analyze
              traffic. You can control cookie preferences through your browser
              settings. Disabling cookies may affect certain features of our
              website.
            </p>
          </section>

          <section data-id="element-365">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-366">
              7. Third-Party Services
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-367">
              Our website may contain links to third-party websites or use
              third-party analytics tools (such as Google Analytics). These
              third parties have their own privacy policies, and we are not
              responsible for their practices. We encourage you to review their
              policies.
            </p>
          </section>

          <section data-id="element-368">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-369">
              8. Changes to This Policy
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-370">
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated effective date. We
              encourage you to review this policy periodically.
            </p>
          </section>

          <section data-id="element-371">
            <h2 className="text-xl font-bold text-[#1B2A4A] mb-3" data-id="element-372">
              9. Contact Us
            </h2>
            <p className="text-slate-600 leading-relaxed" data-id="element-373">
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <div className="mt-3 text-slate-600" data-id="element-374">
              <p data-id="element-375">Bevo Coastal Investments LLC</p>
              <p data-id="element-376">7901 4th Street N, Ste 300</p>
              <p data-id="element-377">St. Petersburg, FL 33702</p>
              <p data-id="element-378">
                Email:{' '}
                <a href="mailto:Info@bevocoastalinvestments.com" className="text-[#E8913A] hover:underline" data-id="element-379">
                  Info@bevocoastalinvestments.com
                </a>
              </p>
              <p data-id="element-380">
                Phone:{' '}
                <a href="tel:8883417570" className="text-[#E8913A] hover:underline" data-id="element-381">
                  (888) 341-7570
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>
    </div>;
}